import React from 'react';
import JobCard from './JobCard';
import { JobWithEmployer } from '../../services/jobService';
import './JobList.scss';

interface JobListProps {
  jobs: JobWithEmployer[];
  layout: 'grid-3' | 'grid-2' | 'list';
  loading?: boolean;
  isGuest?: boolean;
  promotedJobIds?: Set<number>;
  categoryImages?: { [value: string]: string | null };
  savedJobIds?: Set<number>;
  onSaveToggle?: (jobId: number, saved: boolean) => void;
}

const SkeletonCard: React.FC<{ layout: string }> = ({ layout }) => {
  if (layout === 'list') {
    return (
      <div className="skeleton-card skeleton-list">
        <div className="skeleton-header" />
        <div className="skeleton-body">
          <div className="skeleton-line wide" />
          <div className="skeleton-line medium" />
          <div className="skeleton-line narrow" />
        </div>
      </div>
    );
  }
  return (
    <div className="skeleton-card skeleton-grid">
      <div className="skeleton-header" />
      <div className="skeleton-body">
        <div className="skeleton-line wide" />
        <div className="skeleton-line medium" />
        <div className="skeleton-line narrow" />
        <div className="skeleton-tags">
          <div className="skeleton-tag" />
          <div className="skeleton-tag" />
        </div>
      </div>
    </div>
  );
};

const JobList: React.FC<JobListProps> = ({ 
  jobs, 
  layout, 
  loading, 
  isGuest = false, 
  promotedJobIds = new Set(),
  categoryImages = {},
  savedJobIds,
  onSaveToggle
}) => {
  if (loading) {
    const count = layout === 'list' ? 6 : 10;
    return (
      <div className={`job-list job-list-${layout}`}>
        {Array.from({ length: count }).map((_, i) => (
          <SkeletonCard key={i} layout={layout} />
        ))}
      </div>
    );
  }

  if (jobs.length === 0) {
    return (
      <div className="job-list-empty">
        <h3>Skelbimų nerasta</h3>
        <p>Pabandykite pakeisti paieškos kriterijus arba išvalyti filtrus</p>
      </div>
    );
  }

  return (
    <div className={`job-list job-list-${layout}`}>
      {jobs.map((job) => {
        const companyActivity = (job as any).company_activity || (job as any).employer_company_activity;
        const workField = (job as any).work_field;
        const categoryImageUrl = (companyActivity && categoryImages[companyActivity])
          || (workField && categoryImages[workField])
          || null;
        
        return (
          <JobCard 
            key={job.id} 
            job={job} 
            layout={layout} 
            isGuest={isGuest}
            isPromoted={job.id ? promotedJobIds.has(job.id) : false}
            categoryImageUrl={categoryImageUrl}
            savedJobIds={savedJobIds}
            onSaveToggle={onSaveToggle}
          />
        );
      })}
    </div>
  );
};

export default JobList;

